// extracted by mini-css-extract-plugin
export default {"CompanyInfo":"company-view_CompanyInfo__PKt7x","EditButton":"company-view_EditButton__0xpRq"};